<template>
	<div id="pieChart"></div>
</template>


<script>
import * as echart from "echarts";
export default {
	props: ["onlineStatus"],
	data() {
		return {
			pieChart: null
		}
	},
	methods: {
		initOption() {
			let option = {
				tooltip: {
					trigger: 'item'
				},
				series: [
					{
						type: 'pie',
						radius: ['40%', '70%'],
						avoidLabelOverlap: true,
						label: { show: false, },
						labelLine: { show: false },
						data: [
							{
								value: this.onlineStatus.onlineNum,
								name: '在线',
								itemStyle: {
									color: new echart.graphic.LinearGradient(1, 1, 1, 0, [
										{ offset: 0, color: "#95CEF3" },
										{ offset: 1, color: "#4F91BC" },
									])
								}
							},
							{
								value: this.onlineStatus.offlineNum,
								name: '离线',
								itemStyle: {
									color: new echart.graphic.LinearGradient(1, 1, 1, 0, [
										{ offset: 0, color: "#FF6B00" },
										{ offset: 1, color: "#FFB47E" },
									])
								}
							}
						]
					}
				]
			};
			return option
		},
		//更改数据
		refershData() {
			if (!this.pieChart) {
				this.pieChart = echart.init(document.getElementById("elvChart"));
			}
			let option = this.initOption();
			this.pieChart.setOption(option)
		}
	},
	watch: {
		onlineStatus() {
			this.refershData()
		}
	}
}
</script>



<style lang="scss" scoped>
#pieChart {
	width: 100%;
	height: 100%;
}
</style>